// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"488a96df","470":"21eb1501","471":"ddd18565","490":"806a53e5","903":"5bfe0bc8"}[chunkId] + ".css";
};